import React from "react";
import { Badge, IconButton } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function CartIcon() {
  const { cart } = useCart();
  const navigate = useNavigate();
  const totalQty = cart.reduce((sum, item) => sum + item.qty, 0);

  return (
    <IconButton aria-label="Отвори количката" color="black" onClick={() => navigate("/cart")}>
      <Badge badgeContent={totalQty} color="error" overlap="circular" invisible={totalQty === 0}>
        <ShoppingCartIcon fontSize="medium" />
      </Badge>
    </IconButton>
  );
}
